const Topic = {
    "topic": "Test Paper",
    "institute": "Institute",
    "course": "Course",
    "subject": "Subject",
    "topic_name": "Test Paper Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    "error_institute": "Select Institute",
    "error_course": "Select Course",
    "error_subject": "Select Subject",
    "error_name": "Enter Test Paper Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",
    "table_name": "TEST PAPER NAME",
    "table_course": "COURSE",
    "table_subject": "SUBJECT",
    "table_status": "STATUS",

    "topic_question": "Test Paper Question",
    "selected_questions": "Selected Questions",
    "display_order": "Display Order",
    "marks": "Marks",
    "negative_marks": "Negative Marks",
    "error_topic": "Select Test Paper",
    "error_questions": "Select at least one question",
    "error_display_order": "Enter Display Order",
    "error_marks": "Enter Marks",
    "error_negative_marks": "Enter Negative Marks",
    "table_display_order": "ORDER",
    "table_marks": "MARKS",
    "table_negative_marks": "NEGATIVE MARKS",
}

export default Topic;
